const actions = {
	async validateRequired({ dispatch }, input) {
		if (input !== null && input !== undefined && String(input).trim().length > 0) {
			return true;
		}
		return false;
	},

	async validatePassword({ dispatch }, input) {
		const contain8Character = (input.length >= 8);
		const containsUppercase = /[A-Z]/.test(input);
		const containsLowercase = /[a-z]/.test(input);
		const containsNumber = /[0-9]/.test(input);
		const containsSpecial = /[#?!@$%^&*-]/.test(input);
		return contain8Character && containsUppercase && containsLowercase && containsNumber && containsSpecial;
	},

	async validateEmail({ dispatch }, input) {
		/* eslint-disable */
		const isEmail = (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input));
		return isEmail;
	},

	async validatePhoneNumber({ dispatch }, input) {
		const isPhoneNumber = /^[0-9]\d{10,11}$/.test(input);
		return isPhoneNumber;
	},

	async validateNumber({ dispatch }, input) {
		if (!input) return true;
		else {
			const isNumber = /^[0-9]*$/.test(input)
			return isNumber
		}
	},


	//-----VALIDATE IMPORT-----//
	async validateImport({ input, typeCheck, other }) {
		if (!input) {
			return null;
		}
		if (typeCheck == 'required') {
			return this.validateRequired(input);
		}
		else if (type == "length") {

		}
		else if (type == "boolean") {
			if (typeof input == "boolean") {
				return true;
			}
			else return false;
		}
		else if (type == 'int') {
			return this.validateNumber(input);
		}


	}
}

export const validate = {
	namespaced: true,
	actions,
};
